import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../state/language";
import { ensureContent } from "../db/seed";
import { getActiveSession } from "../db";

export default function Splash() {
  const nav = useNavigate();
  const { lang, t } = useLanguage();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await ensureContent();
        if (cancelled) return;
        // Resume mid-session if there is one (§6).
        const active = await getActiveSession();
        if (active && !cancelled) {
          nav(`/session/${active.id}`, { replace: true });
          return;
        }
        // UA-only: skip the language picker, go straight to Modes.
        nav("/modes", { replace: true });
      } catch (e) {
        const msg = e instanceof Error ? e.message : "Unknown error";
        setError(msg);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [lang, nav]);

  // "Портал Паті" → stacked lines inside the portal ring.
  const titleWords = t("app_title").split(" ");

  return (
    <div className="pp-screen items-center justify-center px-6 text-center">
      {/* THE PORTAL — brand signature: the game's name made visible. */}
      <div
        className="pp-portal flex items-center justify-center animate-floatY"
        style={{ width: 250, height: 250, ["--ring" as never]: "9px" }}
      >
        <h1 className="font-display font-black uppercase tracking-tight leading-[1.1] text-[27px]">
          {titleWords.map((w) => (
            <span key={w} className="block">
              {w}
            </span>
          ))}
        </h1>
      </div>
      <p className="mt-9 text-white/70 tracking-wide">{t("app_tagline")}</p>
      <div className="mt-10 text-white/45 text-sm">{error ?? t("loading")}</div>
    </div>
  );
}
